import { Pipe, PipeTransform } from '@angular/core';
import { NUM_AND_SPACE } from 'src/utilities/constants/number-and-space.regex';

@Pipe({
  name: 'noSpaceIntPhone'
})
export class NoSpaceIntPhonePipe implements PipeTransform {

  transform(value: string): string {
    let val = value;
    if (val) {
      val = val.trim();
      val = val.split("").filter(c => RegExp(NUM_AND_SPACE).test(c)).join("");
  
      val = val.split("").filter(c => c !== " ").join("")
      val = val.split("").filter(c => c !== "-").join("")
      val = val.split("").filter(c => c !== "(").join("")
      val = val.split("").filter(c => c !== ")").join("")
  
      val = val.slice(-10);
    }


    return val;
  }

}
